import {API_URL, handleErrorResponse} from "../utility/utility";

export async function findUnattendedAccessTermsVersionsWithPagination(page, limit, signal = null) {
    const token = localStorage.getItem('ACCESS_TOKEN');

    const params = new URLSearchParams();
    params.append('page', page);
    params.append('limit', limit);

    const queryString = params.toString();

    const response = await fetch(`${API_URL}/api/unattended-access-terms-versions?${queryString}`, {
        method  : 'GET',
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        },
        signal  : signal
    });

    await handleErrorResponse(response, 'Failed to fetch unattended access terms versions');

    return response.json();
}

export async function createUnattendedAccessTermsVersion(title, text) {
    if (!title || !text) {
        throw new Error("All fields are required.");
    }

    const token = localStorage.getItem('ACCESS_TOKEN');

    const response = await fetch(`${API_URL}/api/unattended-access-terms-versions`, {
        method  : 'POST',
        body    : JSON.stringify({
            title : title,
            text  : text
        }),
        headers : {
            'Accept'        : 'application/json',
            'Content-Type'  : 'application/json',
            'Authorization' : 'Bearer ' + token
        }
    });

    await handleErrorResponse(response, 'Failed to create unattended access terms version');
}
